import { render, staticRenderFns } from "./EventGroup.vue?vue&type=template&id=8b599e86&scoped=true&"
import script from "./EventGroup.vue?vue&type=script&lang=ts&"
export * from "./EventGroup.vue?vue&type=script&lang=ts&"
import style0 from "./EventGroup.vue?vue&type=style&index=0&id=8b599e86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b599e86",
  null
  
)

export default component.exports